import React, { useEffect, useState } from 'react';
import API from '../services/api';
import { useLanguage } from '../context/LanguageContext';
import './Classes.css';

export default function Classes() {
  const { t } = useLanguage();
  const SECTIONS = [
    { v: 'preschool', l: t('classes.sectionPreschool') },
    { v: 'primary', l: t('classes.sectionPrimary') },
    { v: 'secondary', l: t('classes.sectionSecondary') },
  ];

  const [section, setSection] = useState('preschool');
  const [grades, setGrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedGrade, setSelectedGrade] = useState(null);
  const [students, setStudents] = useState([]);
  const [studentsLoading, setStudentsLoading] = useState(false);
  /* Tutum, doluluq statusu və ayrılmış şagirdlər yalnız Qəbul Şöbəsi, admin,
     direktor və pillə liderlərinə göstərilir. Server bu məlumatı ümumiyyətlə
     göndərmir — burada yalnız görünüş ona uyğunlaşdırılır. */
  const [fullView, setFullView] = useState(false);

  const loadGrades = async () => {
    setLoading(true);
    try {
      const [statsRes] = await Promise.all([
        API.get('/enrollment/stats', { params: { section } }),
      ]);
      setGrades(statsRes.data.grades || []);
      setFullView(statsRes.data.full_view === true);
    } catch (e) {} finally { setLoading(false); }
  };

  useEffect(() => { loadGrades(); }, [section]);

  const openGrade = async (grade) => {
    setSelectedGrade(grade);
    setStudentsLoading(true);
    try {
      const r = await API.get('/enrollment', { params: { section, grade: grade.grade } });
      setStudents(r.data);
    } catch (e) {} finally { setStudentsLoading(false); }
  };

  const backToGrades = () => { setSelectedGrade(null); setStudents([]); };

  const sectionTotal = grades.reduce((s, g) => s + (parseInt(g.total_active) || 0), 0);

  const PAYMENT_LABEL = {
    none: '—',
    depozit: t('classes.paymentDeposit'),
    illik: t('classes.paymentAnnual'),
    depozit_40: t('classes.paymentDeposit40'),
  };

  return (
    <div className="cls-page">
      {/* Başlıq, sekmələr və siyahı bir panelin içindədir — Qəbul
          səhifəsi ilə eyni dizayn dili. */}
      <div className="cls-panel">
      {!selectedGrade && (
        <>
          <div className="cls-header">
            <h2>{t('classes.title')}</h2>
            <span className="cls-count">{sectionTotal} {t('classes.studentSuffix')}</span>
          </div>

          <div className="cls-tabs">
            {SECTIONS.map(s => (
              <button key={s.v} className={'cls-tab' + (section === s.v ? ' active' : '')} onClick={() => setSection(s.v)}>
                {s.l}
              </button>
            ))}
          </div>

          {loading ? <div className="cls-loading">{t('common.loading')}</div> : (
            <div className="cls-grid">
              {grades.map(g => {
                const active = parseInt(g.total_active) || 0;
                const pct = g.capacity > 0 ? Math.round((active / g.capacity) * 100) : 0;
                return (
                  <div key={g.grade} className={'cls-card' + (fullView ? '' : ' cls-card-slim')}
                    onClick={() => openGrade(g)}>
                    <div className="cls-card-name">{g.grade}</div>
                    {fullView ? (
                      <>
                        <div className="cls-card-count">{active} / {g.capacity}</div>
                        <div className="cls-card-bar">
                          <div className="cls-card-fill" style={{width: pct + '%', background: pct >= 100 ? '#dc2626' : pct >= 80 ? '#d97706' : '#007c82'}} />
                        </div>
                        <div className="cls-card-meta">
                          {parseInt(g.staff_count) > 0 && <span className="cls-badge purple">{t('classes.childStaff')}: {g.staff_count}</span>}
                          {parseInt(g.shahid_count) > 0 && <span className="cls-badge red">{t('classes.childMartyr')}: {g.shahid_count}</span>}
                        </div>
                      </>
                    ) : (
                      <div className="cls-card-count">
                        {active} <span className="cls-card-unit">{t('classes.studentSuffix')}</span>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}

      {selectedGrade && (
        <>
          <div className="cls-header">
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <button className="cls-back-btn" onClick={backToGrades}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              </button>
              <div>
                <h2>{selectedGrade.grade}</h2>
                <span className="cls-count">
                  {students.length} {t('classes.studentSuffix')}
                  {fullView && <> · {t('classes.capacity')}: {selectedGrade.capacity}</>}
                </span>
              </div>
            </div>
          </div>

          {studentsLoading ? <div className="cls-loading">{t('common.loading')}</div> : (
            <div className="cls-table-wrap">
              <table className="cls-table">
                <thead>
                  <tr>
                    <th style={{width:36}}>{t('classes.studentNumberCol')}</th>
                    <th>{t('classes.colLastName')}</th>
                    <th>{t('classes.colFirstName')}</th>
                    <th>{t('classes.colFatherName')}</th>
                    {/* Status yalnız səlahiyyətlilərə: qalanlara ayrılanlar
                        onsuz da göndərilmir, sütun həmişə "Aktiv" olardı */}
                    {fullView && <th style={{textAlign:'center',width:70}}>{t('common.status')}</th>}
                    {fullView && <th style={{textAlign:'center',width:80}}>{t('classes.colSignature')}</th>}
                    {fullView && <th style={{textAlign:'center',width:100}}>{t('classes.colPayment')}</th>}
                    {fullView && <th style={{textAlign:'center',width:70}}>{t('classes.colCategory')}</th>}
                  </tr>
                </thead>
                <tbody>
                  {students.length === 0 && (
                    <tr><td colSpan={fullView ? 8 : 4} style={{textAlign:'center',padding:32,color:'#9ca3af'}}>{t('classes.noStudents')}</td></tr>
                  )}
                  {students.map((e, i) => {
                    const isOut = e.enrollment_status === 'out';
                    const lastName = e.student_last_name || (e.student_name || '').split(' ').slice(-1)[0] || '—';
                    const firstName = e.student_first_name || (e.student_name || '').split(' ')[0] || '—';
                    return (
                      <tr key={e.id} className={isOut ? 'cls-row-out' : ''}>
                        <td style={{textAlign:'center',color:'#9ca3af',fontWeight:700}}>{i + 1}</td>
                        <td style={{fontWeight:600}}>{lastName}</td>
                        <td style={{fontWeight:600}}>{firstName}</td>
                        <td>{e.student_father_name || '—'}</td>
                        {fullView && (
                          <td style={{textAlign:'center'}}>
                            <span className={'cls-badge ' + (isOut ? 'gray' : 'green')}>{isOut ? t('classes.statusOut') : t('classes.statusActive')}</span>
                          </td>
                        )}
                        {fullView && (<>
                        <td style={{textAlign:'center'}}>
                          {/* Ayrılmış şagird imza gözləmir — "Gözləyir" yazılmır */}
                          {e.signing_status === 'signed'
                            ? <span className="cls-badge green">{t('classes.signed')}</span>
                            : (isOut || e.signing_status === 'out')
                              ? <span className="cls-dash">—</span>
                              : <span className="cls-badge orange">{t('classes.pending')}</span>}
                        </td>
                        <td style={{textAlign:'center',fontSize:'0.82rem',color:'#374151'}}>
                          {PAYMENT_LABEL[e.payment_status] || '—'}
                        </td>
                        <td style={{textAlign:'center'}}>
                          {e.child_status === 'staff' && <span className="cls-badge purple">{t('classes.childStaff')}</span>}
                          {e.child_status === 'shahid' && <span className="cls-badge red">{t('classes.childMartyr')}</span>}
                        </td>
                        </>)}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
      </div>
    </div>
  );
}
